import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from '../../../../../components/ui/Modal';
import { Button } from '../../../../../components/ui/Button';
import { FilterableSelect } from '../../../../../components/ui/FilterableSelect';
import { Switch } from '../../../../../components/ui/Switch';
import { createSellerCourier } from '../../../../../features/sellers/sellerDetailsThunks';
import { clearCourierError } from '../../../../../features/sellers/sellerDetailsSlice';

/**
 * "Agregar configuración de courier", from the legacy `CompanyDetail`. Offers
 * the admin's couriers this seller does not have yet — the backend allows one
 * row per courier.
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {() => void} props.onClose
 * @param {number} props.companyId
 */
export const AddSellerCourierModal = ({ isOpen, onClose, companyId }) => {
  const dispatch = useDispatch();
  const { settingCouriers, availableCouriers, courierError, courierSaving } = useSelector(
    (state) => state.sellerDetails
  );

  const [courier, setCourier] = useState('');
  const [standBy, setStandBy] = useState(false);
  const [requiresPickups, setRequiresPickups] = useState(false);

  // Every opening starts clean, as the legacy reset its fields and error.
  useEffect(() => {
    if (!isOpen) return;
    setCourier('');
    setStandBy(false);
    setRequiresPickups(false);
    dispatch(clearCourierError());
  }, [isOpen, dispatch]);

  const options = availableCouriers
    .filter((available) => !settingCouriers.some((row) => row.courier === available.courier))
    .map((available) => ({ value: available.courier, label: available.courier }));

  const handleSave = async () => {
    const action = await dispatch(createSellerCourier({
      companyId,
      courier,
      configuration: { stand_by_enabled: standBy, requires_pickup_requests: requiresPickups },
    }));
    if (action.meta.requestStatus === 'fulfilled') onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Agregar configuración de courier"
      testId="seller-courier-add-modal"
      busy={courierSaving}
    >
      <div className="space-y-5">
        {courierError && (
          <div className="bg-red-50 dark:bg-red-900/20 text-danger p-3 rounded-xl border border-red-200 dark:border-red-900 text-sm">
            {courierError}
          </div>
        )}

        <FilterableSelect
          variant="form"
          label="Courier"
          testId="seller-courier-select"
          value={courier}
          onChange={setCourier}
          options={options}
          disabled={options.length === 0}
          placeholder={options.length === 0 ? 'No hay couriers disponibles' : 'Seleccionar...'}
          searchPlaceholder="Buscar courier..."
        />

        <div className="flex flex-col gap-3">
          <Switch checked={standBy} onChange={setStandBy} label="Stand-by activo" />
          <Switch
            checked={requiresPickups}
            onChange={setRequiresPickups}
            label="Solicitudes de retiro activas"
          />
        </div>

        <div className="flex items-center justify-end gap-3 pt-2">
          <Button variant="ghost" onClick={onClose} disabled={courierSaving}>
            Cancelar
          </Button>
          <Button
            variant="primary"
            disabled={!courier}
            loading={courierSaving}
            loadingLabel="Guardando..."
            onClick={handleSave}
          >
            Guardar
          </Button>
        </div>
      </div>
    </Modal>
  );
};
